import axios from 'axios'
import setConfig from '@/config/axios-config'
setConfig(axios)

/**
 * 生成主观缺考有分任务
 * @author chenxb 2024-07-16T14:39:12+0800
 * @param  {Object} params { examId: '', subjectId: '' }
 * @return {[type]}        [description]
 */
const genAbsentSubjectHaveScore = (params) => {
  return axios.get(`/PJService/action/checkTask/generateTasks`, {params})
    .then(res => res.data)
}

/**
 * 获取主观缺考有分任务
 * @author chenxb 2024-07-16T14:56:36+0800
 * @param  {Object} params { examId: '', subjectId: '' }
 * @return {[type]}        [description]
 */
const queryVerifyTask = (params) => {
  return axios.get(`/PJService/action/${params.examId}/${params.subjectId}/getTask`, {params})
    .then(res => res.data)
}
/**
 * 提交主观缺考有分任务
 * @author chenxb 2024-07-16T14:56:36+0800
 * @param  {Object} params { examId: '', subjectId: '' }
 * @return {[type]}        [description]
 */
const submitAbsentHaveScoreResult = (data) => {
  return axios.get(`/PJService/action/${data.examId}/${data.subjectId}/${data.id}/submitResult`)
    .then(res => res.data)
}
/**
 * 清缓存校验任务
 * @author chenxb 2024-07-16T14:56:36+0800
 * @param  {Object} params { examId: '', subjectId: '' }
 * @return {[type]}        [description]
 */
const clearTaskCache = (params) => {
  return axios.get(`/PJService/action/${params.examId}/${params.subjectId}/clearTaskCache`, {params})
    .then(res => res.data)
}
/**
 * 校验任务统计数据
 * @author chenxb 2024-07-16T14:56:36+0800
 * @param  {Object} params { examId: '', subjectId: '' }
 * @return {[type]}        [description]
 */
const getTaskStatic = (params) => {
  return axios.get(`/PJService/action/getTaskStatic`, {params})
    .then(res => res.data)
}
/**
 * 获取学生Omr信息
 * @author chenxb 2025-05-16T14:03:32+0800
 * @param  {Object} params { examId: '', subjectId: '' }
 * @return {[type]}        [description]
 */
const getScannedInfoList = (data) => {
  return axios.post(`/scan/getScannedInfoList`, data)
    .then(res => res.data)
}
/**
 * 保存学生Omr信息
 * @author chenxb 2025-05-16T16:06:12+0800
 * @param  {Object} params { examId: '', subjectId: '' }
 * @return {[type]}        [description]
 */
const saveScanOmrInfo = (data) => {
  return axios.post(`/scan/saveScanOmrInfoWeb`, data)
    .then(res => res.data)
}
/**
 * 没omr数据通过接口生成, 将生成全是#的omr数据
 * @author chenxb 2026-06-15T12:27:13+0800
 * @param  {Object} params { examId: '', subjectId: '',  stuNoList: [] }
 * @return {[type]}        [description]
 */
const genEmptyOmr = (data) => {
  return axios.post(`/scan/genEmptyOmr`, data)
    .then(res => res.data)
}

export {
  clearTaskCache,
  queryVerifyTask,
  getTaskStatic,
  submitAbsentHaveScoreResult,
  genAbsentSubjectHaveScore,
  getScannedInfoList,
  saveScanOmrInfo,
  genEmptyOmr
}



// WEBPACK FOOTER //
// ./src/model/verify-model.js